import req from '../req'
// 关系绑定及佣金设置

// 获取配置详情
export function getSetting (params) {
  return req.get('/setting/commission', params)
}

// 保存设置配置
export function setSetting (params) {
  return req.post('/setting/commission', params)
}
